import { render } from "./Dialog.vue?vue&type=template&id=1c8a7146&scoped=true"
import script from "./Dialog.vue?vue&type=script&lang=js"
export * from "./Dialog.vue?vue&type=script&lang=js"

import "./Dialog.vue?vue&type=style&index=0&id=1c8a7146&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c8a7146"]])

export default __exports__